'use strict';

module.exports = require('./slider');


//////////////////
// WEBPACK FOOTER
// ../~/@mygooder/react-slick/lib/index.js
// module id = 81
// module chunks = 0